"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.landmarkToPixel = void 0;
/**
 * Convert normalized landmark coordinates to pixel coordinates
 */
const landmarkToPixel = (landmark, imageWidth, imageHeight) => {
    return {
        x: Math.round(landmark.x * imageWidth),
        y: Math.round(landmark.y * imageHeight),
    };
};
exports.landmarkToPixel = landmarkToPixel;
//# sourceMappingURL=landmark.js.map